import React, {Component} from 'react'
import {Link} from "react-router-dom"
import {Icon, Pagination} from 'antd'
import {LABEL_STATUS, JOB_SHIPPING_CARRIER} from '../helper/labelFilters'
import SearchField from '../../home/components/filters/SearchField'
import LabelsTable from './table/LabelsTable'
import ImportLabelsPDFV2 from './ImportLabelsPDFV2'
import FilterSelect from "../../shared/FilterSelect"
import {listLabelsV2} from "../../../services/api/labelApi"

class LabelPageV2 extends Component {
    state = {
        labels: [],
        total: 0,
        limit: 50,
        page: 1,
        pages: 1,
        loading: false,
        error: '',
        filters: {},
    }

    componentDidMount() {
        this._fetchLabels()
    }

    _fetchLabels = async () => {
        this.setState({
            loading: true,
        })

        try {
            const {limit, page, filters} = this.state
            const payload = {
                limit,
                page: page,
                ...filters,
            }
            const {data: response} = await listLabelsV2(payload)

            const {data, success, message} = response

            if (!success) {
                throw new Error(message)
            }

            const {labels, total, pages} = data

            this.setState({
                labels,
                total,
                pages,
                loading: false,
                error: '',
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _handlePageChange = (current) => {
        this.setState({
            page: current,
        }, this._fetchLabels)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1,
        }, this._fetchLabels)
    }

    _handleChange = (field, value) => {
        this.setState(({filters}) => {
            return {
                filters: {
                    ...filters,
                    [field]: value,
                },
                page: 1,
            }
        }, this._fetchLabels)
    }

    _handleChangeInput = (field, value) => {
        const arrValues = value.split(/\r|\n|\t|\r\n|\s|,\s|,/)
        this.setState(({filters}) => {
            return {
                filters: {
                    ...filters,
                    [field]: arrValues.filter(item => item !== ''),
                },
                page: 1,
            }
        }, this._fetchLabels)
    }

    render() {
        const {labels, error, page, total, limit, loading} = this.state

        return (
            <div className='LabelPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className='mb-3 d-flex justify-content-between mt-3'>
                            <h3 className='mb-0'>Labels</h3>
                            <div className='d-flex align-items-center'>
                                <ImportLabelsPDFV2 onRefresh={this._fetchLabels}/>

                                <Link to={'/list-job-labels'} className='ant-btn ant-btn-primary ml-3'>
                                    <Icon type="ordered-list" className='mr-2'/>List Job Label
                                </Link>
                            </div>
                        </div>
                        <div className='jumbotron p-3 mb-3'>
                            <div className='row align-items-end'>
                                <div className='col-12 col-xl-auto'>
                                    <FilterSelect
                                        label={'Shipping carrier: '}
                                        options={JOB_SHIPPING_CARRIER}
                                        defaultValue=''
                                        field='tracking_carrier'
                                        onChange={this._handleChange}
                                        value={this.state.filters.tracking_carrier || ''}
                                    />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <FilterSelect
                                        label={'Trạng thái: '}
                                        options={LABEL_STATUS}
                                        defaultValue=''
                                        field='status'
                                        value={this.state.filters.status || ''}
                                        onChange={this._handleChange}
                                    />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <label className='font-weight-bold mb-1'>Barcode</label>
                                    <SearchField
                                        field='barcode'
                                        placeholder='Tìm theo barcode...'
                                        onChangeInput={this._handleChangeInput}
                                    />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <label className='font-weight-bold mb-1'>Tracking number</label>
                                    <SearchField
                                        field='tracking_number'
                                        placeholder='Tìm theo tracking number...'
                                        onChangeInput={this._handleChangeInput}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && <div className='text-danger'>{error}</div>}
                            </div>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>
                                        {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} labels`}</strong>
                                    </div>}
                                onChange={this._handlePageChange}
                                onShowSizeChange={this._handleShowSizeChange}
                            />
                        </div>

                        <LabelsTable labels={labels} error={error} loading={loading} onFetchLabels={this._fetchLabels}/>

                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onChange={this._handlePageChange}
                            onShowSizeChange={this._handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default LabelPageV2
